import { gql } from "@apollo/client"

export const getQuizSubQuestionsQuery = gql`
  query getAllQuizSubQuestions(
    $quizQuestionId: Int
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllQuizSubQuestions(
      quizQuestionId: $quizQuestionId
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        question
        number
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`

export const createQuizSubQuestion = gql`
  mutation createQuizSubQuestion($data: QuizSubQuestionsInput) {
    createQuizSubQuestion(data: $data) {
      id
      status
      error {
        statusCode
        message
        __typename
      }
    }
  }
`
export const updateQuizSubQuestion = gql`
  mutation updateQuizSubQuestion($id: Int!, $data: QuizSubQuestionsInput) {
    updateQuizSubQuestion(id: $id, data: $data) {
      id
      status
      error {
        statusCode
        message
        __typename
      }
    }
  }
`
export const deleteQuizSubQuestion = gql`
  mutation deleteQuizSubQuestion($id: Int!) {
    deleteQuizSubQuestion(id: $id) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
